<div class="toast is-flex text-m ttu" [class.appear]="status$$()" (mouseover)="mouseOver()" (mouseleave)="mouseLeave()">
    <div>{{ props$$()?.title | translate }}</div>
    <div class="cursor-pointer">
        @if (props$$()?.action && props$$()?.message) {
            <div class="text-underline" (click)="clickAction()">{{ props$$().message | translate }}</div>
        } @else {
            <md-icon name="close-s" class="ico-white" (click)="closeNotification()" />
        }
    </div>
</div>
